const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'table.all_projects/SET_TABLE_PARAMS':
      return {
        ...state,
        ...action.params,
      };
    case 'table.all_projects/LIST_ALL_PROJECTS_SUCCESS':
      return {
        ...state,
        data: action.response.data,
        filters: action.response.filters,
        ...action.response.pagination,
      };
    case 'table.all_projects/LIST_SHARED_PROJECTS_SUCCESS':
      return {
        ...state,
        data: action.response.data,
        filters: action.response.filters,
        ...action.response.pagination,
      };
    default:
      return state;
  }
}
